import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { useEffect } from "react";
import { useEmpresa } from "@/context/EmpresaContext";

/**
 * Bloqueia a rota se a empresa ativa não tiver permissão para o módulo.
 * Módulos: produtos, servicos, vendas, vendas-servicos, nfe, nfse
 * Regra: se permissoes_modulos existir e a chave for false, redireciona ao Dashboard.
 * Default (ausente): permitido.
 */
export default function PermissaoRota({ modulo, children }) {
  const { empresaAtual, empresas, loading } = useEmpresa();

  const permitido = !empresaAtual
    || (empresaAtual.permissoes_modulos && (modulo in empresaAtual.permissoes_modulos)
        ? empresaAtual.permissoes_modulos[modulo] !== false
        : (modulo === "assinaturas" ? !!empresaAtual.emite_assinatura : true));

  useEffect(() => {
    if (!loading && empresas?.length && empresaAtual && !permitido) {
      toast.error(`A empresa "${empresaAtual.nome}" não tem permissão para este módulo.`);
    }
  }, [permitido, empresaAtual, empresas, loading]);

  if (loading || !empresas?.length) return children;
  if (!permitido) return <Navigate to="/" replace />;
  return children;
}
